import { Staff } from "@doktor-se/bones-ui/dist/web-shared/types"

const ALL_STAFF_ROLES = [
  "doctor",
  "nurse",
  "psych",
  "coord",
  "group_leader",
  "external",
  "external_nurse",
  "physio",
  "assistant_nurse",
  "dietician",
  "clinical_associate",
  "vet",
  "vet_dk",
  "vet_se",
  "vet_de",
  "vet_nl",
  "vet_no",
  "rtwcoach",
  "listing_uploader"
] as const
type Role = (typeof ALL_STAFF_ROLES)[number]

const isOfType = (value: string): value is Role => {
  return ALL_STAFF_ROLES.find(a => a === value) !== undefined
}

export const findRole = (staff?: Staff) => {
  if (staff?.roles) {
    return staff?.roles?.find(isOfType)
  }
}
